import { type PropsWithChildren, useMemo } from 'react';
import { type PageUIMapHover, PageUIMapHoverContext } from '@alltrails/layout/components/PageUI/PageUIMapHoverContext/PageUIMapHoverContext';
import { useAppDispatch } from '../../redux';
import { updateActiveTrails } from '../../redux/reducer';
import { sectionToTrailResults } from '../../utils/pageUITrailResults';

/**
 * Lights up a section's trail on the map while its card is hovered. Mount it around PageUI sections on pages that have a
 * map; without it the section components fall back to the context's no-ops.
 */
const PageUIMapHoverProvider = ({ children }: PropsWithChildren) => {
  const dispatch = useAppDispatch();

  const value = useMemo<PageUIMapHover>(
    () => ({
      onSectionHover: section => {
        const trails = sectionToTrailResults(section);

        if (trails.length) {
          dispatch(updateActiveTrails(trails));
        }
      },
      onSectionHoverEnd: () => dispatch(updateActiveTrails(undefined))
    }),
    [dispatch]
  );

  return <PageUIMapHoverContext.Provider value={value}>{children}</PageUIMapHoverContext.Provider>;
};

export default PageUIMapHoverProvider;
